import Vue from 'vue'
import Vuex from 'vuex'
import alert from './alert'
import society from './society'
import theme from './theme'

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        alert,
        society,
        theme,
    }
})